export default {
  setLang ({ commit }, payload) {
    commit('SET_LANG', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/i18n/actions.js